import * as React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ChartOptions } from 'chart.js';
import { Line } from 'react-chartjs-2';
import './style.scss';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface Bar {
    c: number;
    h: number;
    l: number;
    o: number;
    t: string;
    v: number;
}

interface AdvancedChartProps {
    symbol: string;
    bars: Bar[];
    currentPeriod: string;
    updateChart?: (period: string) => void;
}

export const AdvancedChartComponent: React.FC<AdvancedChartProps> = ({ bars, currentPeriod }) => {
    const closePrices = bars.map(b => b.c);
    const labels = bars.map(b => {
        const date = new Date(b.t);
        if (currentPeriod === '1D' || currentPeriod === '1W') {
            return date.toLocaleString([], { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        }
        return date.toLocaleDateString([], { month: 'short', day: '2-digit' });
    });

    const first = closePrices.length ? closePrices[0] : 0;
    const last = closePrices.length ? closePrices[closePrices.length - 1] : 0;
    const isPositive = last >= first;

    const data = {
        labels,
        datasets: [
            {
                label: 'Price',
                data: closePrices,
                borderColor: isPositive ? 'rgb(0, 200, 20)' : 'rgb(255, 80, 0)',
                backgroundColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 2,
                pointRadius: 0,
                tension: 0.2,
            },
        ],
    };

    const options: ChartOptions<'line'> = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            intersect: false,
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            y: {
                type: 'linear' as const,
                display: true,
                position: 'left' as const,
            },
            x: {
                display: true,
                ticks: {
                    maxTicksLimit: 8,
                },
            },
        },
    };

    return (
        <div className="advanced-chart">
            <div className="chart-container">
                <Line data={data} options={options} />
            </div>
        </div>
    );
};
